export default __webpack_public_path__ + "static/media/stake-more-zen-eth.c64c51fd.svg";